import { getProxiedServiceUrl } from '@xengage/gw-portals-url-js';
import { JsonRPCService } from '@xengage/gw-portals-transport-js';
import { DocumentUploadService } from '@xengage/gw-portals-document-js';

export default class ClaimService {
    static getClaimSummaries(query, offset, additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('claim'),
            'getClaimSummaries', [query, offset], additionalHeaders);
    }

    static getClaimDetail(claimNumber, additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('claim'),
            'getClaimDetail', [claimNumber], additionalHeaders);
    }

    static getClaimPolicyDetail(claimNumber, additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('claim'),
            'getClaimPolicyDetail', [claimNumber], additionalHeaders);
    }

    static getClaimActivities(claimNumber, additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('claim'),
            'getClaimActivities', [claimNumber], additionalHeaders);
    }

    static getClaimNotes(claimNumber, additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('claim'),
            'getClaimNotes', [claimNumber], additionalHeaders);
    }

    static createClaimNote(claimNumber, noteDTO, additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('claim'),
            'createClaimNote', [claimNumber, noteDTO], additionalHeaders);
    }

    static updateClaimNote(claimNumber, note, additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('claim'),
            'updateClaimNote', [claimNumber, note], additionalHeaders);
    }

    static deleteClaimNote(claimId, noteId, additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('claim'),
            'deleteClaimNote', [claimId, noteId], additionalHeaders);
    }

    static getEFTEnrollmentUrl(claimNumber, additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('claim'),
            'getEFTEnrollmentUrl', [claimNumber], additionalHeaders);
    }

    static getDefaultSearchCriteria(claimNumber, additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('claim'),
            'getDefaultSearchCriteria', [claimNumber], additionalHeaders);
    }

    static cccServiceRequestForEmailorSMS(claimNumber, type, contactInfo, additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('claim'),
            'cccServiceRequestForEmailorSMS', [claimNumber, type, contactInfo], additionalHeaders);
    }

    static searchAppraisers(appraiserSearchCriteriaDTO, additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('claim'),
            'searchAppraisers', [appraiserSearchCriteriaDTO], additionalHeaders);
    }

    static getAppraiserSchedule(claimNumber, appraiserDTO, additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('claim'),
            'getAppraiserSchedule', [claimNumber, appraiserDTO], additionalHeaders);
    }

    static cccServiceRequestForAppraiser(claimNumber, appraiserDTO, additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('claim'),
            'cccServiceRequestForAppraiser', [claimNumber, appraiserDTO], additionalHeaders);
    }

    static bookAppraiserAppointment(claimNumber, selectedTime, appraiserDTO, additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('claim'),
            'bookAppraiserAppointment', [claimNumber, selectedTime, appraiserDTO], additionalHeaders);
    }

    static uploadDocument(file, documentMetadata, additionalHeaders = {}) {
        return DocumentUploadService.send(getProxiedServiceUrl('claimDocumentUpload'),
            file, documentMetadata, additionalHeaders);
    }

    static claimsDocUploadToken(params, additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('claimDocs'),
            'generateUploadToken',
            params, additionalHeaders);
    }

    static claimsRemoveDocument(params, additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('claimDocs'),
            'removeDocument',
            params, additionalHeaders);
    }

    static getNewDocumentsCount(params, authHeaders = {}){
        return JsonRPCService.send(getProxiedServiceUrl('claimDocs'),
            'getNewDocumentsCount',
            params, authHeaders);
    }

    static setDocumentAsViewed(docId, token, authHeader = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('claimDocs'), 'setDocumentAsViewed', 
            [docId, token], authHeader)
    }
}
